"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Burger = function Burger(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 96 96",
    ref: ref
  }, props), (0, _core.jsx)("path", {
    d: "M57.4 64a2.6 2.6 0 010 5.2H22.6a2.6 2.6 0 010-5.2h34.8zm16-18a2.6 2.6 0 010 5.2H22.6a2.6 2.6 0 010-5.2h50.8zm0-18a2.6 2.6 0 010 5.2H22.6a2.6 2.6 0 010-5.2h50.8z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Burger);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Burger, "Burger", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Burger.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Burger.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9CdXJnZXIudHN4Il0sIm5hbWVzIjpbIkJ1cmdlciIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxNQUFzRSxHQUFHLFNBQXpFQSxNQUF5RSxDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUM3RTtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUMsV0FBcEM7QUFBZ0QsSUFBQSxHQUFHLEVBQUVBO0FBQXJELEtBQThERCxLQUE5RCxHQUNFO0FBQ0UsSUFBQSxDQUFDLEVBQUMsa0tBREo7QUFFRSxJQUFBLElBQUksRUFBQztBQUZQLElBREYsQ0FENkU7QUFBQSxDQUEvRTs7ZUFTZSx1QkFBV0QsTUFBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxNIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBCdXJnZXI6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgOTYgOTZcIiByZWY9e3JlZn0gey4uLnByb3BzfT5cbiAgICA8cGF0aFxuICAgICAgZD1cIk01Ny40IDY0YTIuNiAyLjYgMCAwMTAgNS4ySDIyLjZhMi42IDIuNiAwIDAxMC01LjJoMzQuOHptMTYtMThhMi42IDIuNiAwIDAxMCA1LjJIMjIuNmEyLjYgMi42IDAgMDEwLTUuMmg1MC44em0wLTE4YTIuNiAyLjYgMCAwMTAgNS4ySDIyLjZhMi42IDIuNiAwIDAxMC01LjJoNTAuOHpcIlxuICAgICAgZmlsbD1cImN1cnJlbnRDb2xvclwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBmb3J3YXJkUmVmKEJ1cmdlcik7XG4iXX0=